export const isCanada =
  window.location.host.includes('.ca') || window.location.host.includes('.app');
